import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

interface Props {
  discountRateColor: string;
  discountPriceColor: string;
  discountRate: number;
  discountPrice: number;
}
export const DiscountPriceTag: React.FC<React.PropsWithChildren<Props>> = ({
  discountRateColor,
  discountPriceColor,
  discountRate,
  discountPrice,
}) => {
  return (
    <DiscountTag>
      <DiscountRate color={discountRateColor}>{discountRate}%</DiscountRate>
      <DiscountPrice color={discountPriceColor}>{numberWithCommas(discountPrice)}</DiscountPrice>
    </DiscountTag>
  );
};

const DiscountTag = styled.div`
  position: relative;
  top: 1px;
  display: flex;
`;

const DiscountRate = styled.div<{ color: string }>`
  position: relative;
  left: 1px;
  margin: 0 3px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ color }) => color && color};
`;

const DiscountPrice = styled.div<{ color: string }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ color }) => color && color};
  text-decoration: line-through;
`;
